import React from 'react';
import styled, { css } from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { media } from '@/utils/mixin';

import Dealer from './components/Dealer';

function Dealerships() {
  const page = useTypedSelector(selectSinglePost);

  if (!page || !page.dealers || page.dealers.length === 0) {
    return null;
  }

  return (
    <Component>
      <Title>Дилерские центры</Title>
      <DealersList>
        {page.dealers.map(({ id, name, legalName, phones, url }, index) => (
          <Dealer
            key={index}
            url={url ?? ''}
            name={name ?? ''}
            legalName={legalName ?? ''}
            phones={phones && phones.length > 0 ? phones : []}
          />
        ))}
      </DealersList>
    </Component>
  );
}

export default Dealerships;

const Component = styled.div`
  margin-top: 60px;
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    font-size: 28px;
    line-height: 36px;
  `)}

  ${media.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)}
`;

const DealersList = styled.div`
  margin-top: 20px;
`;
